if (!window.dAgency) window.dAgency = {};
window.dAgency.initCarouselBanner = (context) => {
  if (!context || context.querySelectorAll('.swiper-slide').length <= 0) return;

  new Swiper(context, {
    freeMode: true,
    slidesPerView: 1,
    spaceBetween: 16,
    navigation: {
      prevEl: context.querySelector('.carousel-banner__arrow--left'),
      nextEl: context.querySelector('.carousel-banner__arrow--right'),
    },
    breakpoints: {
      769: {
        slidesPerView: 'auto',
        spaceBetween: 32,
      },
    },
  });
};

if (document.readyState != 'loading') {
  [].forEach.call(
    document.querySelectorAll('.carousel-banner__container'),
    (el) => {
      window.dAgency.initCarouselBanner(el);
    },
  );
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(
      document.querySelectorAll('.carousel-banner__container'),
      (el) => {
        window.dAgency.initCarouselBanner(el);
      },
    );
  });
}
